import { Box, Button, Typography } from '@mui/material';
import { ReceiptOutlined } from '@mui/icons-material';
import { useL10n } from '@uplift/hooks';
import { usePsychiatryMatchingContext } from './psychiatry-matching-context';
import { useStyles } from './styles';

export type StartStepProps = {
  disabled?: boolean;
};

export const StartStep: React.VFC<StartStepProps> = ({ disabled }) => {
  const l10n = useL10n();
  const { state, dispatch } = usePsychiatryMatchingContext();
  const { classes } = useStyles({ isDrawer: state.isDrawer });

  const beginMatch = () => {
    dispatch({
      type: 'changeStep',
      payload: 'connect'
    });
  };

  return (
    <Box className={classes.halfWidth}>
      <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column" marginTop="140px">
        <ReceiptOutlined className={classes.startIcon} />
        <Typography variant="h6" color="textSecondary" className={classes.mb}>
          {l10n.clientProfile.psychiatry.noInfoYet}
        </Typography>
        <Button disabled={disabled} color="primary" type="button" variant="contained" onClick={beginMatch}>
          {l10n.clientProfile.psychiatry.connect}
        </Button>
      </Box>
    </Box>
  );
};
